import connectToStores from "alt-utils/lib/connectToStores";
import React, { Component } from "react";

import MinimizedView from "./MinimizedView";

import AuthStore from "../../stores/chat/AuthStore";
import ChatActions from "../../actions/ChatActions";
import ConfigStore from "../../stores/chat/ConfigStore";
import NotificationStore from "../../stores/chat/NotificationStore";

import heartbeat from "../../utils/chat/chatHeartbeat";

const heartbeatConfig = {
    onAuthFail: ChatActions.resetAuth,
    onLoad: ChatActions.loadNotifications,
    onSuccess: ChatActions.loadNotificationsSuccess,
    onError: ChatActions.loadNotificationsFail,
};

export class MinimizedViewContainer extends Component {
    componentWillMount() {
        ChatActions.resetChat();
    }

    componentDidMount() {
        if (this.props.isLoggedIn) {
            const { configId } = this.props;
            this.props.heartbeat.query({
                cfgId: configId,
            });
            this.props.heartbeat.start();
        }
    }

    componentWillReceiveProps(nextProps) {
        const didLoggedInChange = this.props.isLoggedIn !== nextProps.isLoggedIn;

        if (didLoggedInChange) {
            if (nextProps.isLoggedIn) {
                const { configId } = this.props;
                this.props.heartbeat.query({
                    cfgId: configId,
                });
                this.props.heartbeat.start();
            } else {
                this.props.heartbeat.stop();
            }
        }
    }

    componentWillUnmount() {
        this.props.heartbeat.stop();
    }

    static getStores() {
        return [AuthStore, ConfigStore, NotificationStore];
    }

    static getPropsFromStores() {
        return {
            allOpenQuestionsId: NotificationStore.getState().allOpenQuestionsId,
            config: ConfigStore.getConfig(),
            configId: ConfigStore.getConfig().id,
            isLoading: NotificationStore.getState().isLoading,
            isLoggedIn: AuthStore.getState().isLoggedIn,
            notificationsGroupedByAvatar: NotificationStore.getNotificationsGroupedByAvatar(),
            notificationsGroupedByQuestion: NotificationStore.getNotificationsGroupedByQuestion(),
            unansweredOpenQuestionsId: NotificationStore.getState().unansweredOpenQuestionsId,
            unreadMessagesCount: NotificationStore.getUnreadMessagesCount(),
        };
    }

    render() {
        const {
            allOpenQuestionsId,
            config,
            isLoading,
            isLoggedIn,
            notificationsGroupedByAvatar,
            notificationsGroupedByQuestion,
            unansweredOpenQuestionsId,
            unreadMessagesCount,
        } = this.props;

        return (
            <MinimizedView
                allOpenQuestionsId={allOpenQuestionsId}
                labels={config.labels}
                disableAskNewQuestionFromUi={config.disableAskNewQuestionFromUi}
                displayAskQuestion={config.displayAskQuestion}
                isLoading={isLoading}
                isLoggedIn={isLoggedIn}
                notificationsGroupedByAvatar={notificationsGroupedByAvatar}
                notificationsGroupedByQuestion={notificationsGroupedByQuestion}
                unansweredOpenQuestionsId={unansweredOpenQuestionsId}
                unreadMessagesCount={unreadMessagesCount}
            />
        );
    }
}

export default heartbeat("/chat/notifications", heartbeatConfig)(connectToStores(MinimizedViewContainer));
